import { MouseEvent, useMemo, useState } from 'react';
import { SearchProps } from 'semantic-ui-react';
import { IContentExclusion } from '../../../../interfaces/creation-form';
import { contentExclusionMatchesSearch } from '../utils/content-exclusion-matches-search';

export interface ContentExclusionTableRow {
    exclusion: IContentExclusion;
    originalIndex: number;
}

export const useContentExclusionsTableSearch = (contentExclusions: IContentExclusion[]) => {
    const [searchQuery, setSearchQuery] = useState('');

    const tableRows = useMemo<ContentExclusionTableRow[]>(() => {
        const rowsWithIndex = contentExclusions.map((exclusion, originalIndex) => ({
            exclusion,
            originalIndex,
        }));

        const normalizedSearchQuery = searchQuery.trim().toLowerCase();
        if (!normalizedSearchQuery) {
            return rowsWithIndex;
        }

        return rowsWithIndex.filter(({ exclusion }) =>
            contentExclusionMatchesSearch(exclusion, normalizedSearchQuery)
        );
    }, [contentExclusions, searchQuery]);

    const hasExclusions = contentExclusions.length > 0;
    const isSearchActive = searchQuery.trim().length > 0;
    const hasNoSearchResults = hasExclusions && tableRows.length === 0;

    const handleSearchChange = (_: MouseEvent<HTMLElement>, data: SearchProps) => {
        setSearchQuery(data.value ?? '');
    };

    return {
        searchQuery,
        setSearchQuery,
        handleSearchChange,
        tableRows,
        hasExclusions,
        isSearchActive,
        hasNoSearchResults,
    };
};
